import { Stack } from '@mui/material';
import { Suspense } from 'react';
import { Toaster } from 'react-hot-toast';
import { Outlet } from 'react-router-dom';

import { GeneralLoadingFallback } from './general-loading-fallback';
import { Footer } from './main-layout/footer';
import { ContentWrapper } from './main-layout/styled';

export const FooterLayout = () => {
  return (
    <Suspense fallback={<GeneralLoadingFallback />}>
      <Stack display="flex" justifyContent="center" width="100%">
        <ContentWrapper>
          <main style={{ flexGrow: 1 }}>
            <Toaster position="top-right" />
            <Outlet />
          </main>
          <Footer />
        </ContentWrapper>
      </Stack>
    </Suspense>
  );
};
